//@ts-nocheck
import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
} from "chart.js";
import { GraphContainer, GraphInner, XRow } from "./BottomGraph.styled";
import moment from "moment";
import toTitleCase from "@utils/textTools";
import { useStore } from '@store/appStore';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip);

interface IProps {
  chartData: any;
  dataPoints: any;
  Loading?: () => void;
}
const BottomGraph = (props: IProps) => {
  const count = 5;
  const interval = (props.dataPoints.length - 1) / (count - 1);
  const { settings } = useStore();
  // console.log(props.dataPoints)
  let result = [];

  let startMonth = null;
  let endMonth = null;

  if (props.chartData?.length > 0) {
    startMonth = props.chartData?.reduce((oldest, item) => {
      return new Date(item.date) < new Date(oldest.date) ? item : oldest;
    });

    endMonth = props.chartData?.reduce((newest, item) => {
      return new Date(item.date) > new Date(newest.date) ? item : newest;
    });
  }

  const getMin = () => {
    let min = Math.min(...props.dataPoints);
    min = min - 10;
    if (min < 0) return 0;
    return min;
  }



  let tHeight = 0;
  let lowest = null;
  let lowest2 = null;
  let newest = 0;

  for (let i = 0; i < props?.chartData?.length; i++) {
    if (props.chartData[i]?.secondpercentage >= props.chartData[tHeight]?.secondpercentage) {
      tHeight = i;
    }
    if (props.chartData[i]?.secondpercentage <= props.chartData[lowest]?.secondpercentage || lowest === null) {
      lowest = i
    }
  }

  for (let i = tHeight; i < props?.chartData?.length; i++) {
    if (props.chartData[i]?.secondpercentage <= props.chartData[lowest2]?.secondpercentage || lowest2 === null) {
      lowest2 = i
    }
  }
  if (tHeight > 100) {
    tHeight = 0;
    for (let i = 0; i < 100; i++) {
      if (props.chartData[i]?.secondpercentage >= props.chartData[tHeight]?.secondpercentage) {
        tHeight = i;
      }
      if (props.chartData[i]?.secondpercentage <= props.chartData[lowest]?.secondpercentage || lowest === null) {
        lowest = i
      }
    }
  }


  const data = {
    labels: props.dataPoints.map((a, index) => {
      return ""
    }),
    datasets: [
      {
        label: "Percentage",
        data: props.dataPoints,
        fill: true,
        borderColor: "#1f8a93",
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;
          if (!chartArea) return null;
          const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
          gradient.addColorStop(0, "rgba(31,138,147,0.25)");
          gradient.addColorStop(1, "rgba(31, 137, 147, 0)");
          return gradient;
        },
        pointBackgroundColor: "#1f8a93",
        pointBorderColor: "#fff",
        pointRadius: (context) => {
          if (context.dataIndex == lowest || context.dataIndex === tHeight || context.dataIndex === props.chartData?.length - 1 || context.dataIndex === lowest2) {
            return 6
          } else {
            return 0
          }

        },
        pointHoverRadius: 4,
        tension: 0.4,
      },
    ],
  };


  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 20,     // moves the chart area down
        bottom: 0,
        left: 0,
        right: 0
      },

    },
    interaction: {
      mode: "nearest" as const,
      intersect: true,
    },
    scales: {
      x: {
        border: { display: false },
        // hide all x gridlines and any border
        grid: {
          display: false,
          drawBorder: false,
          color: "rgba(0,0,0,0)",
          drawOnChartArea: false,
        },
        ticks: {
          color: "#424242", font: { size: 14, weight: 600 },
          callback: function (tick, index, array) {
            let te = Math.floor(props.dataPoints.length / 5)
            if (index === 0) return toTitleCase(moment(startMonth?.date).format("MMM"))
            else if (index === props.dataPoints.length - 1) return toTitleCase(moment(endMonth?.date).format("MMM"))
            return undefined
          }
        },
      },
      y: {
        min: settings.SHOWPRESENCE ? getMin() : 0,
        // max: highest,

        position: "left",
        border: {
          display: false,      // no axis border
        },

        ticks: {
          count: 3,
          padding: 2,           // means "draw inside chart"
          align: "start",
          callback: (value) => `${Number(value).toFixed(1)}%`,
          color: "#888",
          font: { size: 12 },
        },

        grid: {
          color: "rgba(200, 200, 200, 0.1)",
          drawTicks: false,
          drawBorder: false,
        },
      }
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        backgroundColor: "transparent",
        borderWidth: 0,
        displayColors: false,
        caretSize: 0,
        caretPadding: 12,
        padding: 0,
        bodyAlign: 'center',

        yAlign: "bottom" as const,  // ⬅️ this moves it above the dot
        xAlign: "center" as const,  // ⬅️ centers on the dot

        titleColor: "transparent",
        bodyColor: "#444",

        bodyFont: {
          size: 14,
          weight: "bold" as const,
        },

        callbacks: {
          // dataPoints is copied into state in an effect (ProfileImageGraph), chartData comes straight from
          // props - for a render after the period/student changes the chart can still hold the old, longer
          // points, so a hovered/tapped index may have no day yet.
          label: (ctx) => {
            const percentage = `${Number(ctx.parsed.y).toFixed(1)}% `;
            const day = props.chartData?.[ctx.dataIndex];
            return day ? [percentage, moment(day.date).format("DD-MM-yyyy")] : [percentage];
          },
        },
      }
    },
    clip: false as const,
  };

  // console.log(props.dataPoints)

  return (
    <GraphContainer>
      <GraphInner>
        <Line data={data} options={options} />
      </GraphInner>
    </GraphContainer>
  );
};

export default BottomGraph;
